import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-gray-50 animate-fadeIn mt-10 md:mt-20">
      <div className="max-w-md">
        <h1 className="text-8xl font-bold text-red-500 animate-bounce">404</h1>
        <h2 className="text-2xl font-semibold mt-4 text-gray-800">Oops! Page Not Found</h2>
        <p className="mt-2 text-gray-600">
          The page you're looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-3 bg-red-500 text-white font-medium rounded-lg hover:bg-pink-600 transition transform hover:scale-105"
        >
          Go Back Home
        </Link>
      </div>
      {/* <div className="mt-8">
        <img
          src="https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
          alt="404 illustration"
          className="w-64 mx-auto animate-bounce"
        />
      </div> */}
    </div>
  );
};

export default NotFound;
